import customAxios from "../../customAxios";
import {GET_ALL_CITY} from "../../routes";

interface IProps {
  provinceCode?: string;
  searchCity?: string;
}
const getAllCity = async (props: IProps) => {
  if (!props.provinceCode) return false;
  var thisUrl = `?ProvinceCode=${props.provinceCode}`;

  if (props?.searchCity) thisUrl += `&city=${props.searchCity}`;
  try {
    return (await customAxios.get(GET_ALL_CITY + thisUrl)).data;
  } catch (error: any) {
    console.log({GET_ALL_CITY: error});
  }
};

export default getAllCity;
